export var AutomationStatus;
(function (AutomationStatus) {
    AutomationStatus["DRAFT"] = "DRAFT";
    AutomationStatus["ACTIVE"] = "ACTIVE";
    AutomationStatus["PAUSED"] = "PAUSED";
    AutomationStatus["ARCHIVED"] = "ARCHIVED";
})(AutomationStatus || (AutomationStatus = {}));
export var AutomationType;
(function (AutomationType) {
    /** @deprecated Product decision: simple automation flows are no longer supported. */
    AutomationType["SIMPLE"] = "SIMPLE";
    AutomationType["ADVANCED"] = "ADVANCED";
})(AutomationType || (AutomationType = {}));
/**
 * Module a flow belongs to. Legacy flows carry no value and are treated as MARKETING
 * by the backend, so survey-side creates must send SURVEY explicitly.
 */
export var AutomationDomain;
(function (AutomationDomain) {
    AutomationDomain["MARKETING"] = "MARKETING";
    AutomationDomain["SURVEY"] = "SURVEY";
})(AutomationDomain || (AutomationDomain = {}));
/**
 * `GET_PROFILE` and `LOOP` were retired on 2026-09-04: the Audience node now fans a run out over
 * every member of a saved audience, one run per guest, so neither a single-profile lookup nor an
 * in-execution loop has anything left to do. A stored node whose type is not in this enum renders
 * as a neutral "Unknown step" card rather than breaking the canvas.
 */
export var NodeType;
(function (NodeType) {
    // Triggers
    NodeType["MANUAL_TRIGGER"] = "MANUAL_TRIGGER";
    NodeType["FORM_SUBMITTED"] = "FORM_SUBMITTED";
    // LEAD_CREATED = 'LEAD_CREATED',
    NodeType["RESERVATION_CREATED"] = "RESERVATION_CREATED";
    NodeType["RESERVATION_STATUS_CHANGED"] = "RESERVATION_STATUS_CHANGED";
    // LEAD_SCORE_CHANGED = 'LEAD_SCORE_CHANGED',
    NodeType["SCHEDULED_TRIGGER"] = "SCHEDULED_TRIGGER";
    NodeType["SURVEY_SUBMITTED"] = "SURVEY_SUBMITTED";
    NodeType["SURVEY_REMINDER_DUE"] = "SURVEY_REMINDER_DUE";
    // TAG_ADDED = 'TAG_ADDED',
    // Actions
    NodeType["SEND_EMAIL"] = "SEND_EMAIL";
    NodeType["SEND_PUSH"] = "SEND_PUSH";
    // SEND_WHATSAPP = 'SEND_WHATSAPP',
    // ADD_TAG = 'ADD_TAG',
    // REMOVE_TAG = 'REMOVE_TAG',
    // UPDATE_LEAD_SCORE = 'UPDATE_LEAD_SCORE',
    // ASSIGN_TO_USER = 'ASSIGN_TO_USER',
    // CREATE_TASK = 'CREATE_TASK',
    // WEBHOOK = 'WEBHOOK',
    // AI_PROCESS = 'AI_PROCESS',
    // ALERT_TRAINER = 'ALERT_TRAINER',
    NodeType["AUDIENCE"] = "AUDIENCE";
    NodeType["TEAM_MEMBERS"] = "TEAM_MEMBERS";
    NodeType["FULL_SYNC_AUDIENCE"] = "FULL_SYNC_AUDIENCE";
    NodeType["SURVEY_INVITE"] = "SURVEY_INVITE";
    /** Builds a survey report's files once per run, before any fan-out; Send team email attaches them. */
    NodeType["SURVEY_REPORT"] = "SURVEY_REPORT";
    /** One email to the team member of the run, so only below a Team members step. */
    NodeType["SEND_TEAM_EMAIL"] = "SEND_TEAM_EMAIL";
    // Flow Control
    NodeType["IF_CONDITION"] = "IF_CONDITION";
    NodeType["CONTINUE_IF"] = "CONTINUE_IF";
    NodeType["WAIT"] = "WAIT";
    /** "Wait for everyone": ends the per-member part of a fan-out; the parent waits, then continues from it once every member run has settled. */
    NodeType["AFTER_EVERYONE"] = "AFTER_EVERYONE";
    /** "Stop": a true end, the run stops here whatever is connected below. */
    NodeType["FINISH"] = "FINISH";
    // SPLIT_TEST = 'SPLIT_TEST',
    // END = 'END'
})(NodeType || (NodeType = {}));
export var ExecutionStatus;
(function (ExecutionStatus) {
    ExecutionStatus["PENDING"] = "PENDING";
    ExecutionStatus["RUNNING"] = "RUNNING";
    ExecutionStatus["WAITING"] = "WAITING";
    ExecutionStatus["COMPLETED"] = "COMPLETED";
    ExecutionStatus["FAILED"] = "FAILED";
    ExecutionStatus["CANCELLED"] = "CANCELLED";
})(ExecutionStatus || (ExecutionStatus = {}));
export var ConditionType;
(function (ConditionType) {
    ConditionType["FIELD_EQUALS"] = "FIELD_EQUALS";
    ConditionType["FIELD_NOT_EQUALS"] = "FIELD_NOT_EQUALS";
    ConditionType["FIELD_CONTAINS"] = "FIELD_CONTAINS";
    ConditionType["FIELD_GREATER_THAN"] = "FIELD_GREATER_THAN";
    ConditionType["FIELD_LESS_THAN"] = "FIELD_LESS_THAN";
    ConditionType["FIELD_EXISTS"] = "FIELD_EXISTS";
    ConditionType["FIELD_NOT_EXISTS"] = "FIELD_NOT_EXISTS";
    ConditionType["CUSTOM_SCRIPT"] = "CUSTOM_SCRIPT";
})(ConditionType || (ConditionType = {}));
/**
 * What the migration had to change while rebuilding a flow written against the retired node types.
 * Every code is one sentence in the editor's migrated banner; the two optional fields fill it in.
 */
export var AutomationMigrationNoteCode;
(function (AutomationMigrationNoteCode) {
    AutomationMigrationNoteCode["AUDIENCE_SAVED"] = "AUDIENCE_SAVED";
    AutomationMigrationNoteCode["GET_PROFILE_REMOVED"] = "GET_PROFILE_REMOVED";
    AutomationMigrationNoteCode["LOOP_REMOVED"] = "LOOP_REMOVED";
    AutomationMigrationNoteCode["LOOP_DONE_BRANCH_DISCONNECTED"] = "LOOP_DONE_BRANCH_DISCONNECTED";
    /** The loop's done branch now follows an inserted "Wait for everyone" (AFTER_EVERYONE) node. */
    AutomationMigrationNoteCode["LOOP_DONE_BRANCH_MOVED"] = "LOOP_DONE_BRANCH_MOVED";
    AutomationMigrationNoteCode["LOOP_REFERENCE_UNRESOLVED"] = "LOOP_REFERENCE_UNRESOLVED";
    AutomationMigrationNoteCode["GET_PROFILE_REFERENCE_UNRESOLVED"] = "GET_PROFILE_REFERENCE_UNRESOLVED";
    AutomationMigrationNoteCode["AUDIENCE_FILTER_MISSING"] = "AUDIENCE_FILTER_MISSING";
})(AutomationMigrationNoteCode || (AutomationMigrationNoteCode = {}));
